var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventTypeAlert01 = function SvgEventTypeAlert01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "event_type_alert-01_svg2__a",
    x1: 58.82,
    x2: 163.85,
    y1: 209.05,
    y2: 83.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__b",
    x1: 46.76,
    x2: 151.79,
    y1: 198.99,
    y2: 73.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__c",
    x1: 29.47,
    x2: 134.5,
    y1: 184.57,
    y2: 58.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__d",
    x1: -22.48,
    x2: 82.55,
    y1: 141.24,
    y2: 15.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__e",
    x1: 81.41,
    x2: 186.45,
    y1: 227.89,
    y2: 101.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__f",
    x1: -13.86,
    x2: 91.17,
    y1: 148.43,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__g",
    x1: -37.75,
    x2: 67.28,
    y1: 128.5,
    y2: 2.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_alert-01_svg2__a",
    id: "event_type_alert-01_svg2__h",
    x1: 35.55,
    x2: 140.58,
    y1: 189.64,
    y2: 63.71
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.03 188.28h-17.58V170.7c0-3.24-2.62-5.86-5.86-5.86h-5.86V100c0-29.08-23.66-52.73-52.73-52.73S47.27 70.93 47.27 100v64.84h-5.86c-3.24 0-5.86 2.62-5.86 5.86v17.58H17.97c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h164.06c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86M58.98 100c0-22.62 18.4-41.02 41.02-41.02s41.02 18.4 41.02 41.02v64.84H58.98zm93.75 88.28H47.27v-11.72h105.47v11.72Z",
    style: {
      fill: "url(#event_type_alert-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 129.3c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86 5.86-2.62 5.86-5.86-2.62-5.86-5.86-5.86",
    style: {
      fill: "url(#event_type_alert-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 82.42c-3.24 0-5.86 2.62-5.86 5.86v23.44c0 3.24 2.62 5.86 5.86 5.86s5.86-2.62 5.86-5.86V88.28c0-3.24-2.62-5.86-5.86-5.86",
    style: {
      fill: "url(#event_type_alert-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83 100c0-3.24-2.62-5.86-5.86-5.86H5.86C2.62 94.14 0 96.76 0 100s2.62 5.86 5.86 5.86h12.11c3.24 0 5.86-2.62 5.86-5.86",
    style: {
      fill: "url(#event_type_alert-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14 94.14h-12.11c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h12.11c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86",
    style: {
      fill: "url(#event_type_alert-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 23.83c3.24 0 5.86-2.62 5.86-5.86V5.86c0-3.24-2.62-5.86-5.86-5.86s-5.86 2.62-5.86 5.86v12.11c0 3.24 2.62 5.86 5.86 5.86",
    style: {
      fill: "url(#event_type_alert-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85 46.14c1.14 1.14 2.64 1.72 4.14 1.72s3-.57 4.14-1.72a5.86 5.86 0 0 0 0-8.29l-8.29-8.29a5.86 5.86 0 0 0-8.29 0 5.86 5.86 0 0 0 0 8.29l8.29 8.29Z",
    style: {
      fill: "url(#event_type_alert-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 47.85c1.5 0 3-.57 4.14-1.72l8.29-8.29a5.86 5.86 0 0 0 0-8.29 5.86 5.86 0 0 0-8.29 0l-8.29 8.29a5.86 5.86 0 0 0 0 8.29 5.85 5.85 0 0 0 4.14 1.72Z",
    style: {
      fill: "url(#event_type_alert-01_svg2__h)"
    }
  }));
};
export default SvgEventTypeAlert01;